import Vue from 'vue'
import VueRouter from 'vue-router';
import { Store } from 'vuex';
import {setTitleWithApp} from '@/utils/util'
import miguRingSDK from '../../tool/migusInit';
var isWeta365 = window.location.href.indexOf('source=weta365') !== -1;
console.log('---isWeta365',isWeta365)
let titleMap={
    "/textToVideo":"小说推文",
    "/app":"元创岛",
    "/downloadApp":"元创岛",
    "/protocol":"元创岛",
    "/privacy":"元创岛",
    "/commonList":"元创岛",
    "/sdkList":"元创岛",
    "/feige/protocol":"跟飞哥学AI",
    "/feige/privacy":"跟飞哥学AI",
    "/feige/commonList":"跟飞哥学AI",
    "/feige/sdkList":"跟飞哥学AI",
    "/payMiddlePage": "元创岛",
    "/realPaySuccess": "元创岛",
    "/voiceClone": "元创岛",
    "/voicePaySuccess": "元创岛",
    "/extraList": "提取历史",
    "/fileExtract": "文案提取",
    "/accredit": "授权我的作品账号",
    "/activity": "我的账号",
    "/activityManager": "授权账号管理",
    "/leaderboard": "排行榜",
    "/textGenerate": "文案生成",
    "/textGenerateList": "生成历史",
    "/welfareCenter": "福利中心",
    "/signIn": "每日签到",
    "/exchangeBean": "魔豆兑换",
    "/welfareRules": "活动规则",
    "/welfareRecords": "获得/兑换记录",
    "/main": "元创岛",
    "/sameTemplate": "教程模版",
    "/my": "我的",
    "/works": "作品管理",
    "/brainHistory": '全部历史数据',
    "/smart-clip": "1/4 解析视频",
    "/smart-clip-step2": "2/4 标出解说文案",
    "/smart-clip-step3": "3/4 文案改写",
    "/smart-clip-step4": "4/4 设置视频参数",
    /********** AI 小工具 **********/
    "/ai-gold-start": "黄金开场",
    "/ai-title": "智能标题",
    "/ai-description": "智能描述",
    "/ai-rewrite": "智能改写",
    "/ai-image": "文生图",
    "/ai-image-detail": "生图详情",
    "/ai-duplicate-removal": '去重工具'
}

let weta365TitleMap={
    "/":"奇妙元",
    "/article":"奇妙元"
}
const saveRouterPath = (path) => {
    if (path) {
        let prePath = localStorage.getItem('curPath')
        localStorage.setItem('prePath', prePath)
        localStorage.setItem('curPath', path)
    }
}
export default function initRouter(router:VueRouter,store: Store<any>){
 let titleMaps = isWeta365?weta365TitleMap:titleMap;
    router.beforeEach((to, from, next) => {
        saveRouterPath(to.path)
        document.title =titleMaps[to.path] || to?.meta?.title ||to.name || ""
        setTitleWithApp()
        try {
          const isMiguRoute = typeof to.path === 'string' && to.path.indexOf('/migu') === 0;
          console.log('isMiguRoute', isMiguRoute, (window as any).__mgaInited, (window as any).AmberWebSdk);
          if (isMiguRoute && !(window as any).__mgaInited) {
            // if ((window as any).AmberWebSdk) {
              // var etm = 1 * Date.now();
              // var initOption = [];
              // initOption.push(['_enterTime', etm]);
              // initOption.push(['_inAppIsUpload', true]);
              // initOption.push(['_accountId', 'e8f2f2748ab5412e86e2466f92ee304a']);
              // (window as any).AmberWebSdk._amberInit(initOption)
              // console.log('_amberTrack AmberWebSdk');
              
              var _mgds = _mgds || [];
              (window as any)._mgds = _mgds;
              (function () {
                // begin 新增的集成代码片段
                (window as any).amberDataStore = (window as any).amberDataStore || [];
                (window as any)._amberEventTrack || ((window as any)._amberEventTrack = function (id: any, data: any) {
                  if ((window as any).amberDataStore.length < 1000) {
                    (window as any).amberDataStore.push({ ID: id, POP: data }) // 缓存埋点数据
                  }
                });
                (window as any)._amberTrack || ((window as any)._amberTrack = function (id: any, data: any) {
                  if (Array.isArray(id)) {
                    id.forEach(function (v: any) { (window as any)._amberEventTrack(v.ID, v.POP) })
                  } else if (typeof id === 'string') {
                    (window as any)._amberEventTrack(id, data)
                  }
                });
                (window as any).AmberWebSdk || ((window as any).AmberWebSdk = {
                  _amberTrack: (window as any)._amberTrack,
                  addUDID: function (id: any) { (window as any).AmberWebSdk._udid = id }, // 缓存 udid
                  setExtra: function (ext: any) { (window as any).AmberWebSdk._extra = ext } // 缓存 ext
                });
                // end 新增的集成代码片段
                var etm = 1 * Date.now();
                _mgds.push(['_enterTime', etm]);
                _mgds.push(['_accountId', 'e8f2f2748ab5412e86e2466f92ee304a']);
                (function () {
                  var vds = document.createElement('script');
                  vds.type = 'text/javascript';
                  vds.async = true;
                  vds.src = 'https://ambersdk.migu.cn/uemjs/amber-web-sdk-min.js';
                  var s = document.getElementsByTagName('script')[0];
                  s.parentNode.insertBefore(vds, s);
                })();
              })();
              //主动调用进行初始化操作
              (window as any).__mgaInited = true;
            // }
          }
          // 初始化咪咕SDK，挂载到 window 供其他地方调用
          if (!(window as any).__miguSDKInited) {
            (window as any).miguSDK = miguRingSDK;
            miguRingSDK.init('miguInitCallback').then(() => {
              (window as any).__miguSDKInited = true;
            }).catch((e: any) => {
              console.warn('miguSDK init failed:', e?.message);
            });
          }
        } catch (e) {}
         next()
    });
}
